import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

type Config = Required<Pick<AST.Program, 'body'>> & Partial<AST.Program>;

export const createProgram = (config: Config): AST.Program => ({
  type: NodeType.Program,
  blockParams: [],
  loc,
  ...config,
});
